import { render, staticRenderFns } from "./sec-estaractualizado.vue?vue&type=template&id=0457706b&scoped=true&"
import script from "./sec-estaractualizado.vue?vue&type=script&lang=js&"
export * from "./sec-estaractualizado.vue?vue&type=script&lang=js&"
import style0 from "./sec-estaractualizado.vue?vue&type=style&index=0&id=0457706b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0457706b",
  null
  
)

export default component.exports